<template>
  <v-footer v-if="!footerClose" app padless style="position: unset">
    <v-card flat tile width="100%" height="100%">
      <CustomRow>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" class="d-flex align-center" :class="$vuetify.breakpoint.xs ? 'justify-center' : ''">
              <v-img src="@/assets/image/ticketplus-logo-bk.svg" min-width="100px" max-width="129px" />
            </v-col>
            <v-col cols="12" sm="6" :class="$vuetify.breakpoint.xs ? 'justify-center' : 'justify-end'" align-self="center"
              class="d-flex">
              <a href="https://www.facebook.com/ticketplusasia/" class="no-decoration" target="_blank">
                <v-icon color="primary" size="40"> mdi-facebook </v-icon>
              </a>
              <div class="ml-3">
                <a href="https://www.instagram.com/ticketplusasia/" class="no-decoration" target="_blank">
                  <v-icon color="primary" size="40"> mdi-instagram </v-icon>
                </a>
              </div>
            </v-col>
          </v-row>
          <v-row class="md-sm-5">
            <v-spacer />
            <v-col cols="12" class="px-0 d-block text-left text-sm-center">
              <div class="mx-sm-4 d-block d-sm-inline-block">
                <v-icon color="primary" class="mb-0 mr-1" dense>mdi-phone</v-icon>
                <span class="mr-2 text-small">{{
                  $t("footer_service_phone")
                }}</span>
                <a href="tel:+886227781570" class="no-decoration text-small" target="_blank">02-2778-1570</a>
              </div>
              <div class="mx-sm-4 d-block d-sm-inline-block">
                <v-icon color="primary" class="mb-0 mr-1" dense>mdi-email</v-icon>
                <span class="mr-2 text-small">{{
                  $t("footer_service_email")
                }}</span>
                <a href="mailto:service@farentasia.com" class="no-decoration text-small"
                  target="_blank">service@farentasia.com</a>
              </div>
              <div class="mx-sm-4 d-block d-sm-inline-block">
                <v-icon color="primary" class="mb-0 mr-1" dense>mdi-clock</v-icon>
                <span class="mr-2 text-small">{{
                  $t("footer_service_time")
                }}</span><span>{{ $t("footer_service_time_content") }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </CustomRow>
      <div class="primary text-center white--text pa-6 text-eight">
        {{ $t("footer_copyright") }}｜{{ $t('tax_no') }}83118342
      </div>
    </v-card>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheLayoutFooter",
  data: () => ({
    icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
  }),
  computed: {
    footerClose() {
      return this.$route.meta.order;
    },
  },
};
</script>

<style lang="scss" scoped>
footer.v-footer .v-card {
  background: #eaeaea;
}

a.no-decoration:link {
  color: #444444;
}
</style>